import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { languageAction, currencyAction, updateUser, emitAlert} from '@shared/redux/actions/actions-store-state.model';
import { ProfileApiService } from '@modules/profile/profile-api.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'astrea-profile-config',
  templateUrl: './profile-config.component.html',
  styleUrls: ['./profile-config.component.scss']
})
export class ProfileConfigComponent implements OnInit, OnDestroy {

  public user: any;
  @Input() isUserShared!: boolean;
  @Input()
    set setUser(u: any) {
      this.user = u;
      this.matchData();
    };

  public loadingLanguage = false;
  public loadingCurrency = false;

  public formLanguage = this.formBuilder.group({
    language: ['', Validators.required],
  });
  public formCurrency = this.formBuilder.group({
    currency: ['', Validators.required],
  });

  private newsletter$: Subject<any> = new Subject();
  public newsletter = false;

  constructor(
    private api: ProfileApiService,
    private store: Store<AppState>,
    private formBuilder: UntypedFormBuilder,
    private _t: TranslateService,
    private cdref: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.listenNewsletter();
  }

  ngOnDestroy() {
    if (this.newsletter$) this.newsletter$.complete();
  }

  matchData(): void {
    this.formLanguage.patchValue({ language: this.user.language });
    this.formCurrency.patchValue({ currency: this.user.currency });
    this.newsletter = this.user.newsletter;
  }

  updateLanguage(): void {
    if (this.formLanguage.valid) {
      this.loadingLanguage = true;
      this.api.putUser(this.formLanguage.value)
        .subscribe({
          next: res => {
            // El cambio de idioma se realiza en @shared/components/menu-navbar.components.ts
            this.store.dispatch(languageAction({ language: this.formLanguage.get('language')!.value }));

            this.loadingLanguage = false;
            this.store.dispatch(updateUser({ user: res.result.data }));
            this.dispatchAlertUser();
          }
        });
    }
  }

  updateCurrency(): void {
    if (this.formCurrency.valid) {
      this.loadingCurrency = true;
      this.api.putUser(this.formCurrency.value)
        .subscribe({
          next: res => {
            // El cambio de divisa se realiza en @shared/components/menu-navbar.components.ts
            this.store.dispatch(currencyAction({ currency: this.formCurrency.get('currency')!.value }));

            this.loadingCurrency = false;
            this.store.dispatch(updateUser({ user: res.result.data }));
            this.dispatchAlertUser();
          }
        });
    }
  }

  dispatchAlertUser(): void {
    this.store.dispatch(emitAlert({
      message: this._t.instant('alert.info_update_ok'),
      alertType: 'success'
    }));
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }


  /* ********** NEWSLETTER ********** */

  handleNewsletter(): void {
    this.newsletter$.next(this.newsletter);
  }

  listenNewsletter(): void {
    this.newsletter$
      .pipe(
        debounceTime(350)
      )
      .subscribe({
        next: () => {
          this.api.putUser({ newsletter: this.newsletter })
          .subscribe({
            next: res => {
              this.store.dispatch(updateUser({ user: res.result.data }));
            }
          });
        }
      });
  }

}
